<template lang="html">
<div class="order-backdrop">
 <div class="list">
   <div class="Ierror">
    <span class="cha" @click="cha">×</span>
    <template v-if="orderList">
      <div v-show="newConstruction">
        <h1 class="LHeader">选择报名人</h1>
        <ul class="listcontent">
          <li>
            <div class="jiang"><Icon type="checkmark-round"></Icon></div>
            <div class="message">
              <span>张毅</span>
              <span>133****1333</span>
            </div>
            <div class="img"><img src="../../assets/redact.png" alt=""></div>
          </li>
          <li>
            <div class="jiang"><Icon type="checkmark-round"></Icon></div>
            <div class="message">
              <span>张毅</span>
              <span>133****1333</span>
            </div>
            <div class="img"><img src="../../assets/redact.png" alt=""></div>
          </li>
          <li>
            <div class="jiang"><Icon type="checkmark-round"></Icon></div>
            <div class="message">
              <span>张毅</span>
              <span>133****1333</span>
            </div>
            <div class="img"><img src="../../assets/redact.png" alt=""></div>
          </li>
          <li>
            <div class="jiang"><Icon type="checkmark-round"></Icon></div>
            <div class="message">
              <span>张毅</span>
              <span>133****1333</span>
            </div>
            <div class="img"><img src="../../assets/redact.png" alt=""></div>
          </li>
        </ul>
        <div class="btn">确定</div>
        <div class="new-construction"><span @click="Construction">新建报名人</span></div>
      </div>
      <div v-show="!newConstruction">
          <h1 class="LHeader">添加报名人</h1>
          <!-- <div class="info">
            <p><span>姓名</span><input type="text" class="addName"/><i class="error"></i></p>
            <p class="zhSpecial"><span class="zhP">证件号码</span><select class="Certificates"><option selected="selected">身份证</option><option>护照</option><option>台胞证</option><option>回乡证</option></select><input type="text" class="identity" /><i class="error"></i></p>
            <p v-if="zhOverseas" class="oversea"><span>护照号</span><input type="text" class="zhPassportHZ"/><i class="error"></i></p>
            <p><span>手机</span><input type="text" class="phone"/><i class="error"></i></p>
            <p class="zhSpecial renzhi" v-if="interval==1?true:false"><span class="zhP">任职机构</span><input type="text" class="passport zhPassport1"/><i class="error"></i></p>
            <p class="zhiwu" v-if="interval==1?true:false"><span>职务</span><input type="text" class="passport zhJigou"/><i class="error"></i></p>
            <div class="delate" ><span>－</span>删除</div>
          </div> -->
          <div class="new-info">
            <p><span>姓名</span><input type="text"/><i class="error"></i></p>
            <p ><span>证件号码</span><select class="Certificates"><option selected="selected">身份证</option><option>护照</option><option>台胞证</option><option>回乡证</option></select><input type="text" class="identity" /><i class="error"></i></p>
            <p ><span>护照号</span><input type="text"/><i class="error"></i></p>
            <p><span>手机</span><input type="text"/><i class="error"></i></p>
            <p><span>任职机构</span><input type="text"/><i class="error"></i></p>
            <p><span>职务</span><input type="text"/><i class="error"></i></p>
          </div>
          <div class="new-btn" @click="newBtn">提交</div>
      </div>
    </template>
    <template v-if="contactsList">
      <div v-show="newConstruction">
        <h1 class="LHeader">选择联系人</h1>
        <ul class="listcontent" v-if="linkmanList">
          <li v-for="(item,index) in linkmanList">
            <div class="jiang" @click="linkmanListPitch(index)"><Icon type="checkmark-round" v-if="index === linkmanListTrue"></Icon></div>
            <div class="message">
              <span>{{item.name}}</span>
              <span>{{item.phone?item.phone:'' | capitalize }}</span>
            </div>
            <div class="img" @click="compileConstruction(index)"><img src="../../assets/redact.png" alt=""></div>
          </li>
        </ul>
        <div class="btn" @click="compileBtn" v-if="linkmanList">确定</div>
        <div class="new-construction"><span @click="Construction">新建联系人</span></div>
      </div>
      <div v-show="!newConstruction">
          <h1 class="LHeader">添加联系人</h1>
          <div class="new-info">
            <p><span>姓名</span><input type="text" v-model="ConstructionArray.name"/><i class="error"></i></p>
            <p><span>手机</span><input type="text" v-model="ConstructionArray.phone"/><i class="error"></i></p>
          </div>
          <div class="new-btn" @click="newBtn">提交</div>
      </div>
    </template>


  </div>
 </div>
</div>
</template>

<script>
export default {
props:['orderList','contactsList'],
data(){
  return{
    newConstruction:true,
    linkmanListnone:'',
    linkmanListTrue:'',
    linkmanList:[
      // {
      //   id:1,
      //   name:'张毅一',
      //   phone:'13315134765',
      //   display:false
      // },
      // {
      //   id:2,
      //   name:'张毅二',
      //   phone:'13315134765',
      //   display:false
      // },
      // {
      //   id:3,
      //   name:'张毅三',
      //   phone:'13315134765',
      //   display:false
      // },
      // {
      //   id:4,
      //   name:'张毅四',
      //   phone:'13315134765',
      //   display:false
      // },
      // {
      //   id:5,
      //   name:'张毅五',
      //   phone:'13315134765',
      //   display:false
      // }
    ],
    ConstructionArray:{
      name:'',
      phone:''
    }
  }
},
created (){
},
mounted:function (){
  var that=this
  this.$ajax({
    method:'get',
    url:'/api/user_contacts'
  }).then(data => {
    // console.log(data.data.data)
    //对象深复制，不考虑循环引用的情况
    this.linkmanList = data.data.data
  }).catch(error =>{
    console.log(error)
  })
},
methods:{
  cha:function(){
    this.$emit("cha",false)
  },
  cloneObj:function(from) {
    return Object.keys(from)
        .reduce((obj, key) => (obj[key] = clone(from[key]), obj), {});
  },
//数组深复制，不考虑循环引用的情况
cloneArr:function(from) {
    return from.map((n) => clone(n));
},
  clone:function(from) {
    if (from instanceof Array) {
        return this.cloneArr(from);
    } else if (from instanceof Object) {
        return this.cloneObj(from);
    } else {
        return (from);
    }
},
  Construction:function(){
    this.ConstructionArray={
      name:'',
      phone:'',
      id:''
    }
    this.newConstruction = !this.newConstruction
  },
  newBtn:function(){
    if(!( /^[\u4e00-\u9fa5]{2,5}$/.test(this.ConstructionArray.name))){
      alert('姓名填写不正确')
      return
    }else if(this.ConstructionArray.phone.length!==11){
      alert('请填写11位手机号')
      return
    }
    if(this.ConstructionArray.id!==''){
      this.$ajax({
        method:'put',
        url:'/api/user_contacts/'+this.ConstructionArray.id,
        data:this.ConstructionArray
      }).then(data => {
        if(data.data.data){
          this.$ajax({
            method:'get',
            url:'/api/user_contacts'
          }).then(data => {
            this.linkmanList = data.data.data
            this.newConstruction = !this.newConstruction
          }).catch(error =>{
            console.log(error)
          })
        }

      }).catch(error =>{
        console.log(error)
      })
    }else{
      this.$ajax({
        method:'post',
        url:'/api/user_contacts',
        data:this.ConstructionArray
      }).then(data => {
        if(data.data.data){
          this.$ajax({
            method:'get',
            url:'/api/user_contacts'
          }).then(data => {
            this.linkmanList = data.data.data
            this.newConstruction = !this.newConstruction
          }).catch(error =>{
            console.log(error)
          })
        }
      }).catch(error =>{
        console.log(error)
      })
    }

  },
  linkmanListPitch:function(index){
    this.linkmanListnone = this.linkmanListTrue
    this.linkmanListTrue = index
      if(this.linkmanListnone === '') {
      }else{
        this.linkmanList[this.linkmanListnone].display = false
      }
    this.linkmanList[index].display=true
  },
  compileConstruction:function(index){
   this.ConstructionArray = this.linkmanList[index]
   this.newConstruction = !this.newConstruction
 },
 compileBtn:function(){
   this.$emit("cha",false)
   if(this.linkmanListTrue===''){
   }else{
     this.$emit('linkman',this.linkmanList[this.linkmanListTrue])
   }
 }
},
filters: {
  capitalize: function(value){
    if(value === ''){
      return
    }
    return value.substr(0, 3) + '****' + value.substr(7);
  }
}
}
</script>

<style lang="css" scoped>
.order-backdrop{width:100%;height:100%;background:rgba(0,0,0,.3);position:fixed;left:0;top:0;z-index: 999;}
.cha{position: absolute;right:0;top:0;width:36px;line-height:36px;font-size: 36px;text-align: center;color:#a3a3a2;}
.cha:hover{color:#01b784;background:#e6e6e6;}
.list{width:440px;height:auto;background:#fff;
transform:translateX(-50%) translateY(-50%);
-ms-transform:translateX(-50%) translateY(-50%); 	/* IE 9 */
-moz-transform:translateX(-50%) translateY(-50%);	/* Firefox */
-webkit-transform:translateX(-50%) translateY(-50%); /* Safari 和 Chrome */
-o-transform:translateX(-50%) translateY(-50%);
position:absolute;left:50%;top:50%;z-index: 5;}
.LHeader{font-size: 20px;text-align: center;margin-top:30px;font-weight: 400;}
.jiang{width:20px;height:20px;line-height:20px;border:1px solid #dfdfdf;background:#fff;font-size: 18px;text-align: center;margin:3px 10px;color:#11cc99;}
.listcontent{width: 90%;max-height: 183px;margin:20px auto;overflow: auto;}
::-webkit-scrollbar
{
    width: 8px;
    height: 8px;
    background-color: #ffffff;
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb
{
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
    background-color: #11cc99;
}
.listcontent li{display: flex;align-items: center;border-bottom:1px solid #f0f0f0;padding-top:10px;padding-bottom: 10px;}
.listcontent li .message{display: flex;flex-direction: column;margin-left: 15px;}
.listcontent li .message span{width: 77px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
.listcontent li .img{margin-left: 220px;}
.listcontent li .img img{width: 20px;height:20px;}
.btn{width:200px;line-height:40px;border:0;margin:15px auto;background:#01b784;color:#fff;text-align: center;border-radius: 5px;margin-top: 30px;}
.new-construction{margin: auto;color: #11cc99;text-align: center;margin-bottom: 30px;}
.new-construction span{cursor: pointer;}
.new-info{width:90%;margin: 20px auto;position:relative;margin-bottom: 10px}
.new-info p input{width:200px;height:30px;border:1px solid #dfdfdf;margin-left:20px;}
.new-info p>span{width:80px;display:inline-block;text-align: right;color:#4f4f4f;}
.new-info p{line-height:45px;}
.new-btn{width:200px;line-height: 30px;border:0;margin: 30px auto;background:#01b784;color:#fff;text-align: center;border-radius: 5px;}
</style>



// WEBPACK FOOTER //
// list.vue?e44bc39a